import { useLayoutEffect } from "react";

import { useHandleDeviceUnknown } from "@/hooks";
import { isSupportedObjectSearchDeviceType } from "@/shared/objectSearchDevice";
import { getStorage } from "@/shared/store";
import type { DeviceType } from "@/types";

import { AddressPatternObjectSearch } from "./object-search";

const ObjectSearch = () => {
  const deviceType = getStorage("deviceType") as DeviceType;
  // session の deviceType が空・不正なら弾く（一覧 API の切り替えは検索結果ページで getObjectSearchRoute）
  const canUseObjectSearch = isSupportedObjectSearchDeviceType(deviceType);
  const { toastAndToSelectDevice } = useHandleDeviceUnknown();

  useLayoutEffect(() => {
    if (!canUseObjectSearch) toastAndToSelectDevice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canUseObjectSearch]);

  if (!canUseObjectSearch) return null;

  return <AddressPatternObjectSearch />;
};

export default ObjectSearch;
